<template lang="pug">
  SspLayout(area="core")
    template(slot="actions")
      router-link.btn.btn-default(:to="{ name: 'groupEdit', params: { id: groupId } }")
        i.fa.fa-edit
        span.ml5 Edit
      button.btn.btn-default(@click="$refs.addUserModal.open()")
        i.fa.fa-edit
        span.ml5 Add User
      button.btn.btn-primary(@click="$refs.createGroupModal.open()")
        i.fa.fa-edit
        span.ml5 Add Child Group
      button.btn.btn-danger(@click="deleteGroup")
        i.fa.fa-trash
        span.ml5 Delete
    GroupDetails(ref="groupDetails" :groupId="groupId" @removeUser="removeUserFromGroup" @goToGroup="goToGroup" @goToUser="goToUser")

    CreateGroupModal(ref="createGroupModal" @success="goToNewChildGroup" @error="$emit('error', $event)")
    AddUserModal(ref="addUserModal" :groupId="groupId" @success="$refs.groupDetails.reload()" @error="$emit('error', $event)")

</template>

<script>
import miniToastr from 'mini-toastr'
import Security from '@/service/apis/Security'
import CreateGroupModal from './CreateGroupModal'
import GroupDetails from './GroupDetails'
import AddUserModal from './AddUserModal'

export default {
  data: () => ({
    groupUsers: null
  }),
  methods: {
    removeUserFromGroup(id) {
      const req = {
        groupId: this.groupId,
        userId: id
      }
      this.$confirm({ text: 'Are you sure you wish to remove this user from the group?' })
        .then((conf) => {
          if (conf) {
            Security.removeUserFromGroup(this.groupId, id, req)
              .then(() => {
                miniToastr.success('User was successfully removed')
                this.$refs.groupDetails.reload()
              })
              .catch((e) => { this.$emit('error', e) })
          }
        })
    },
    deleteGroup() {
      this.$confirm({ text: 'Are you sure you wish to delete this group?' })
        .then((conf) => {
          if (conf) {
            Security.deleteGroup(this.groupId, { groupId: this.groupId })
              .then(() => {
                miniToastr.success('Group was successfully deleted')
                this.$router.push('/core/management/groups')
              })
              .catch((e) => { this.$emit('error', e) })
          }
        })
    },
    goToGroup(id) {
      this.$router.push({ name: 'group', params: { id } })
    },
    goToUser(id) {
      this.$router.push({ name: 'user', params: { id } })
    },
    goToNewChildGroup(data) {
      this.$router.push({ name: 'group', params: { id: data.groupId } })
    }
  },
  computed: {
    groupId() {
      return parseInt(this.$route.params.id, 10)
    }
  },
  components: {
    CreateGroupModal,
    GroupDetails,
    AddUserModal
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/core/management/group/Group.vue